import { useCallback, useEffect, useState } from "react";

/** Counts down from `seconds` once a second, stopping at 0; `restart` starts it again. */
export function useCountdown(seconds: number): { remaining: number; restart: (s: number) => void } {
  const [remaining, setRemaining] = useState(seconds);
  const running = remaining > 0;

  useEffect(() => {
    if (!running) return;
    const id = setInterval(() => setRemaining((r) => Math.max(0, r - 1)), 1000);
    return () => clearInterval(id);
  }, [running]);

  const restart = useCallback((s: number) => setRemaining(Math.max(0, s)), []);
  return { remaining, restart };
}
